<template>
  <div class="andetail box">
    <div class="left_content"></div>
    <div class="andetail_content">
      <p class="breakhead book_nav" v-if="breakArr.type == 1">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">方剂库</span>
        <span class="nav_middle" @click="goablist(3)">{{breakArr.ksname}}</span>
        <span class="nav_current">{{breakArr.name}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 2">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">推荐医家</span>
        <span class="nav_middle" @click="goablist(3)">{{breakArr.name}}</span>
        <span class="nav_current">{{breakArr.ksname}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 3">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">方剂库</span>
        <span class="nav_middle" @click="goablist(3)">{{breakArr.name}}</span>
        <span class="nav_current">{{breakArr.ksname}}</span>
      </p>
      <p class="breakhead book_nav" v-if="breakArr.type == 4">
        <router-link to="index" tag="span" class="nav_home">首页</router-link>
        <span class="nav_middle" @click="goindex(2)">方剂库</span>
        <span class="nav_current">{{breakArr.name}}</span>
      </p>
      <!-- {{detailtArr}} -->
      <h3 class="andetail_title">
        <span v-if="isfree">限时免费</span>
        {{case_name}}
      </h3>
      <div class="andetail_div">
        <div class="andetail_first" v-for="(pitem,pindex) in detailtArr" :key="pindex">
          <div
            class="andetail_p"
            v-for="(item,index) in pitem"
            :key="index"
            v-if="item.value.length>0"
          >
            <p
              v-if="item.name.length >4"
              class="andetail_p_name"
              :style="'width: '+item.name.length*17+'px;'"
            >{{item.name}}</p>
            <p v-else class="andetail_p_name">{{item.name}}</p>
            <!-- <p>{{item.value[0]}}</p> -->
            <p class="andetail_p_content">
              <span v-for="(bitem,bindex) in item.value">{{bitem}}</span>
            </p>
          </div>
        </div>
        <!-- <div class="andetail_follow" v-for="(ppitem,ppindex) in detailtArr_follow" :key="ppindex">
          <div class="andetail_follow_title">
            <p>{{follow_title[ppindex]}}诊</p>
          </div>
          <div class="andetail_first" v-for="(pitem,pindex) in ppitem" :key="pindex">
            <p
              class="andetail_p"
              v-for="(item,index) in pitem"
              :key="index"
              v-if="item.value.length>0"
            >
              <span>{{item.name}}</span>
              <span>{{item.value[0]}}</span>
            </p>
          </div>
        </div>-->
        <!-- <div class="buy_now" v-if="need_buy">
          <p>还有&nbsp;{{percentage}}&nbsp;的精彩内容</p>
          <div v-if="islogin" @click="buy_now">支付&nbsp;￥{{price}}&nbsp;继续阅读</div>
          <router-link v-else tag="div" to="login">登录阅读全文</router-link>
        </div>
        <div class="buy_now" v-else>
          <p v-if="!islogin">还有&nbsp;{{percentage}}&nbsp;的精彩内容</p>
          <router-link v-if="!islogin" tag="div" to="login">登录阅读全文</router-link>
        </div>-->
      </div>
      <!-- <div class="collect_active" v-show="!is_collection&&islogin&&!need_buy" @click="collection">收藏</div>
      <div
        class="collect_active collect_not"
        v-show="is_collection&&islogin&&!need_buy"
        @click="collection"
      >取消收藏</div> -->
    </div>
    <div class="right_content"></div>
    <div class="gotop" v-show="isgotop" @click="gotop"></div>
  </div>
</template>
<script>
import { addstamp } from "../../utils/stamp";
export default {
  data() {
    return {
      detailtArr: [],
      case_id: null,
      follow_title: [],
      detailtArr_follow: [],
      detailtArr_first: [],
      breakArr: [],
      current_page: 1,
      total_pages: null,
      price: 0,
      is_buy: true,
      need_buy: true,
      isfree: false,
      isgotop: false,
      case_name: null,
      islogin: false,
      percentage: null,
      is_collection: false,
      collect_id: null,
      meta_title: "",
      is_c:true
    };
  },
  metaInfo() {
    return {
      title: this.meta_title,
    };
  },
  created() {
    if (typeof this.$store.state.user_id != "undefined") {
      this.islogin = true;
    }
    if (this.$store.state.mechanism == 'C端账号') {
      this.is_c = true;
    } else {
      this.is_c = false;
    }
    if (this.$route.query.t == 1) {
      this.breakArr = {
        name: this.$route.query.name,
        ksname: this.$route.query.ks,
        type: this.$route.query.t,
      };
    } else if (this.$route.query.t == 2) {
      this.breakArr = {
        name: this.$route.query.name,
        ksname: this.$route.query.ks,
        type: this.$route.query.t,
      };
    } else {
      this.breakArr = {
        name: this.$route.query.name,
        ksname: this.$route.query.ks,
        type: this.$route.query.t,
      };
    }
    this.case_id = this.$route.query.cid;
    this.getDetail();
  },
  mounted() {
    var that = this;
    var two = document.documentElement.clientHeight / 2;
    window.addEventListener("scroll", function (e) {
      var top = document.documentElement.scrollTop;
      if (top > two) {
        that.isgotop = true;
      } else {
        that.isgotop = false;
      }
    });
  },
  methods: {
    alertdialog() {
      // this.$message({
      //   type: "info",
      //   message: "暂时无法阅读",
      // });
      this.$alert("该资料暂不对个人用户开放，请联系客服了解详情", "提示", {
        confirmButtonText: "确定",
      });
    },
    collection() {
      let that = this;
      // this.is_collection = !this.is_collection;
      if (!this.is_collection) {
        //   // this.$message("收藏成功");
        let params = {
          user_id: this.$store.state.user_id,
          type: "fang",
          fang_id: this.$route.query.cid,
        };
        var sign = addstamp(params);
        delete params.token;
        params["sign"] = sign;
        this.$axios.post("collect", params).then(function (res) {
          // console.log(res);
          if (res.data.status_code == 200) {
            that.is_collection = true;
            that.collect_id = res.data.data.collect_id;
            that.$message({
              message: "收藏成功",
              iconClass: "colloction_icon",
            });
          }
        });
      } else {
        let params = {
          user_id: this.$store.state.user_id,
          collect_id: this.collect_id,
        };
        var sign = addstamp(params);
        delete params.token;
        params["sign"] = sign;
        // console.log(params);
        let url = "collect";
        this.$axios.delete(url, { params }).then(function (res) {
          if (res.data.status_code == 200) {
            // console.log(res);
            that.is_collection = false;
            that.collect_id = null;
          }
        });
      }
    },
    getDetail() {
      let that = this;
      let url = "zk_fang/fang/" + this.case_id;
      // 暂定修改《--
      let params = {};
      // let params = {
      //   user_id: this.$store.state.user_id
      // };
      if(!this.is_c){
        params['user_id']=this.$store.state.user_id
      }
      // --》
      this.$axios.get(url, { params }).then(function (res) {
        // console.log(res.data.data);
        if (res.data.status_code == 200) {
          // that.detailtArr = res.data.data.info;
          that.is_collection = res.data.data.is_collect;
          that.collect_id = res.data.data.collect_id;
          that.data_handling(res.data.data.info);
          that.price = res.data.data.price / 100;
          that.case_name = res.data.data.title;
          that.percentage = res.data.data.percentage;
          that.is_buy = res.data.data.is_buy;
          if (that.is_buy) {
            that.need_buy = false;
          } else {
            if (that.price == -1) {
              // that.isfree = true;
              that.need_buy = false;
            } else if (that.price == 0) {
              // that.isfree = false;
              that.need_buy = false;
            } else if (that.price > 0) {
              // that.isfree = false;
              that.need_buy = true;
            }
          }
          let title = 0;
          let tindex = 0;
          for (let i = 0; i < res.data.data.info.length; i++) {
            if (res.data.data.info[i].name == "出处") {
              title = 1;
              tindex = i;
              break;
            }
          }
          if (title == 1) {
            that.meta_title =
              that.case_name + " " + res.data.data.info[tindex].value[0];
          } else {
            that.meta_title = that.case_name;
          }
          //   console.log(that.detailtArr.length)
        }
      });
    },
    data_handling(tempArr) {
      let index = 0;
      let count = 8;
      let newTemp = [];
      for (let i = 0; i < tempArr.length; i++) {
        index = parseInt(i / count);
        if (newTemp.length <= index) {
          newTemp.push([]);
        }
        newTemp[index].push(tempArr[i]);
      }
      this.detailtArr = newTemp;
      // console.log(newTemp);
    },
    goindex(num) {
      if (num == 1) {
        this.$router.push({
          path: "/index",
        });
      } else {
        this.$router.push({
          path: "/fang",
        });
      }
    },
    buy_now() {
      this.$router.push({
        path: "/order",
        query: {
          type: 4,
          cid: this.case_id,
        },
      });
    },
    goablist(num) {
      if (num == 1) {
        this.$router.push({
          path: "/anList",
          query: {
            name: this.breakArr.name,
            ks: this.breakArr.ksname,
            t: this.breakArr.type,
          },
        });
      } else if (num == 2) {
        this.$router.push({
          path: "/anList",
          query: {
            name: this.breakArr.name,
            t: this.breakArr.type,
          },
        });
      } else {
        this.$router.push({
          path: "/fangList",
          query: {
            name: this.$route.query.name,
            t: 3,
          },
        });
      }
    },
    // 回到顶部
    gotop() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
<style scoped lang="scss"  type="text/css">
@import "../../assets/style/an/an_detail.scss";
@import "../../assets/style/an/book_nav.scss";
</style>